import React, { useEffect, useRef, useState } from 'react';

import { applyScrollState } from '../../hooks/use-apply-scroll-state';
import { Button, Overlay, Popover, Table } from 'react-bootstrap';
import { customDiagnosticType } from '@components/editor-page/editor-pane/utils/error-extractor';
import { EditorView } from '@codemirror/view';
import { ExclamationCircle } from 'react-bootstrap-icons';
import { UiIcon } from '@components/common/icons/ui-icon';
import { useApplicationState } from '@hooks/common/use-application-state';
import { useCodemirrorReferenceContext } from '@components/editor-page/change-content-context/codemirror-reference-context';

export const FormatCheckerButton = () => {
  const [codeMirrorRef] = useCodemirrorReferenceContext();
  const { count, formatIssues } = useApplicationState(
    (state) => state.formatChecker
  );
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState<any>();
  const ref = useRef<any>(null);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setShow(!show);
    setTarget(event.target);
  };
  const handleOutsideClick = (event: MouseEvent) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setShow(false);
    }
  };

  useEffect(() => {
    if (show) {
      document.addEventListener('mousedown', handleOutsideClick);
    } else {
      document.removeEventListener('mousedown', handleOutsideClick);
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [show]);
  return count !== 0 ? (
    <div ref={ref}>
      <Overlay
        show={show}
        target={target!}
        placement='top'
        container={ref}
        containerPadding={20}>
        <Popover id='popover-contained'>
          <Popover.Header className='p-1'>
            <div className='p-1 d-flex align-items-center gap-2'>
              <UiIcon className='m-0' icon={ExclamationCircle} />
              <p className='m-0'>Issues</p>
            </div>
          </Popover.Header>
          <Popover.Body
            className='overflow-auto'
            style={{ maxHeight: '30rem' }}>
            <div className='d-flex flex-column'>
              <Table striped bordered>
                <thead>
                  <tr>
                    <th className='p-1'>#</th>
                    <th className='p-1'>Line No.</th>
                    <th className='p-1'>Message</th>
                  </tr>
                </thead>
                <tbody>
                  {formatIssues.map((issue: customDiagnosticType, index: number) => (
                    <tr
                      key={index}
                      className='cursor-pointer'
                      onClick={() =>
                        applyScrollState(codeMirrorRef as EditorView, {
                          firstLineInView: issue.lineNo,
                          scrolledPercentage: 0
                        })
                      }>
                      <td>{index + 1}</td>
                      <td className='text-center'>{issue.lineNo}</td>
                      <td>{issue.message}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Popover.Body>
        </Popover>
      </Overlay>
      <Button
        active
        onClick={handleClick}
        className='position-relative bg-light border-light'
        title='Format Issue'
        variant='light'>
        <UiIcon className='text-danger' icon={ExclamationCircle} size='20' />
        <div
          style={{
            top: '0rem',
            right: '-0.3rem',
            minWidth: '1.5rem',
            height: '1.5rem'
          }}
          className='align-items-center position-absolute bg-info rounded-circle'>
          {count}
        </div>
      </Button>
    </div>
  ) : null;
};
